module.exports = __webpack_public_path__ + "assets/img/course_big_cat5.9aed6c3d.png";